import client from './index'

import { ApiResponse } from '@/models/api'

import { Session } from '@/store/auth'

export const signIn = (data: { email: string; password: string }) => {
  return client.post<ApiResponse<Session>>('/auth/sign-in', data)
}

export const getMe = () => {
  return client.get<ApiResponse<Partial<Session>>>('/me')
}
